/* eslint-disable no-param-reassign */
function swap(items, leftIndex, rightIndex) {
  const temp = items[leftIndex];
  items[leftIndex] = items[rightIndex];
  items[rightIndex] = temp;
}

function partition(items, left, right, parameterType) {
  let pivot;
  switch (parameterType) {
    case 'number':
      pivot = items[Math.floor((right + left) / 2)].tag_usage_count_by_user;
      break;
    case 'string':
      pivot = items[Math.floor((right + left) / 2)].label.toLowerCase();
      break;
    default:
      break;
  }
  let i = left;
  let j = right;
  while (i <= j) {
    switch (parameterType) {
      case 'number':
        while (items[i].tag_usage_count_by_user < pivot) {
          i++;
        }
        while (items[j].tag_usage_count_by_user > pivot) {
          j--;
        }
        break;
      case 'string':
        while (items[i].label.toLowerCase() < pivot) {
          i++;
        }
        while (items[j].label.toLowerCase() > pivot) {
          j--;
        }
        break;
      default:
        break;
    }
    if (i <= j) {
      swap(items, i, j);
      i++;
      j--;
    }
  }
  return i;
}

function quickSort(items, left, right, parameterType = 'number') {
  try {
    let index;
    if (items.length > 1) {
      index = partition(items, left, right, parameterType); // index returned from partition
      if (left < index - 1) {
        // more elements on the left side of the pivot
        quickSort(items, left, index - 1, parameterType);
      }
      if (index < right) {
        // more elements on the right side of the pivot
        quickSort(items, index, right, parameterType);
      }
    }
    return items;
  } catch (err) {
    return items;
  }
}

function flattenArray(data) {
  try {
    const result = [];
    data.forEach(item => {
      if (item && typeof item === 'object' && item.length > 0) {
        result.push(...item);
      } else if (item) result.push(item);
    });
    return result;
  } catch (err) {
    return data;
  }
}

function sortTagsByLabelWithSameUserCount(data) {
  try {
    const queries = [];
    const result = [];
    let queryUserCount = null;
    let queryMap = [];
    const lastItemIndex = data.length - 1;
    data.forEach((item, index) => {
      if (queryUserCount === null)
        queryUserCount = item.tag_usage_count_by_user;
      if (queryUserCount !== item.tag_usage_count_by_user) {
        queries.push(queryMap);
        queryUserCount = item.tag_usage_count_by_user;
        queryMap = [];
      }
      queryMap.push(item);
      if (index === lastItemIndex) queries.push(queryMap);
    });
    queries.forEach(map => {
      result.push(quickSort(map, 0, map.length - 1, 'string'));
    });
    return flattenArray(result);
  } catch (err) {
    return data;
  }
}

export const updateTagUsageCount = (data, globalTagsData) => {
  try {
    if (!globalTagsData || globalTagsData?.length === 0) return data;
    return data.map(tag => {
      // eslint-disable-next-line no-param-reassign
      delete tag.tag_usage_count_by_user;
      return {
        ...tag,
        tag_usage_count_by_user: globalTagsData.find(
          item => item.tag_id === tag.tag_id
        ).tag_usage_count_by_user
      };
    });
  } catch (err) {
    return data;
  }
};

export const updateCompanyTagsList = (tags, tags_removed, tags_added) => {
  try {
    return tags.map(tag => {
      if (tags_added.includes(tag.tag_id))
        return {
          ...tag,
          tag_usage_count_by_user: tag.tag_usage_count_by_user + 1
        };
      if (tags_removed.includes(tag.tag_id))
        return {
          ...tag,
          tag_usage_count_by_user: tag.tag_usage_count_by_user - 1
        };
      return tag;
    });
  } catch (err) {
    return tags;
  }
};

/* Sorts an array of tags by usage, whenever value of tag_usage_count_by_user
    is same for two tags then label takes precedence
  - data -> accepts the array that needs to be sorted
  - key -> key is the attribute you want sorting to happen with
  - Order -> Order is ascending or descending
 */
export default (data, order = 'DESC') => {
  try {
    if (!data || data?.length === 0) return data;
    let response = quickSort(data, 0, data.length - 1);
    if (order === 'ASC') {
      response = sortTagsByLabelWithSameUserCount(response);
      return response;
    }
    response = response.reverse();
    response = sortTagsByLabelWithSameUserCount(response);
    return response;
  } catch (err) {
    return data;
  }
};
